export const Colors = {
  blue: "#246E98",
  lightBlue1: "#ddf2ed",
  lightBlue2: "#fcfdfe",
  lightBlue3: "#c7eaf2",
  lightGreen: "#d1ede6",
  white: "#ffffff",
};
